import { Icon } from "@iconify/react/dist/iconify.js";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";

import { convertRoleToPath } from "../utils/enum";

const BottomTab = () => {
  const auth = useSelector((state) => state.auth);

  const tabs = [
    {
      icon: "solar:home-smile-angle-broken",
      text: "خانه",
    },
    {
      icon: "solar:box-minimalistic-broken",
      text: "دسته بندی ها",
      link: "/category",
    },
    {
      icon: "solar:box-broken",
      text: "محصولات",
      link: "/product",
    },
    {
      icon: "solar:reorder-broken",
      text: "سفارشات",
      link: "/orders",
    },
    {
      icon: "solar:user-broken",
      text: "حساب کاربری",
      link: "/profile",
    },
  ];

  return (
    <div
      className="d-xl-none bottom-tab d-footer w-100 position-fixed border-top"
      style={{ bottom: 0, left: 0 }}
    >
      {tabs.map((tab, index) => {
        const linkUrl = `/${convertRoleToPath(auth.role)}${tab.link || ""}`;
        return (
          <div className="col px-0" key={linkUrl}>
            <NavLink
              to={linkUrl}
              className={`bottom-tab-item ${
                index === 2 ? "bottom-tab-item-center" : ""
              }`}
              end
            >
              <Icon icon={tab.icon} className="text-xxl" />
              <span className="d-block">{tab.text}</span>
            </NavLink>
          </div>
        );
      })}
    </div>
  );
};

export default BottomTab;
